import React, { useMemo, useState } from "react";
import { ArrowLeft, Users, UserPlus } from "lucide-react";
import PageShell from "../dashboard/PageShell";

const AddProjectMember: React.FC = () => {
  const id = useMemo(() => {
    try {
      const parts = window.location.pathname.split("/").filter(Boolean);
      // expected: topics/approval/detail/:id/members/add → last meaningful is id at index length-3
      return parts[parts.length - 3] || "";
    } catch {
      return "";
    }
  }, []);

  const [form, setForm] = useState({
    selectedMember: "",
    fullName: "",
    phone: "",
    email: "",
    unit: "",
    position: "",
    role: "",
    work: "",
  });

  const change = (field: string, value: string) =>
    setForm((p) => ({ ...p, [field]: value }));

  return (
    <PageShell title="Thêm thành viên tham gia">
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3 min-w-0">
            <button
              onClick={() => {
                // Navigate back to project detail with members tab active
                const projectId = window.location.pathname.split("/")[4]; // Extract project ID from URL
                window.location.href = `/topics/approval/detail/${projectId}`;
              }}
              aria-label="Go back"
              className="p-3 rounded-full text-[#337ab7] bg-blue-50 hover:bg-blue-100 transition-colors"
            >
              <ArrowLeft className="h-5 w-5" />
            </button>
            <Users className="h-5 w-5 text-[#337ab7]" />
            <h1 className="text-lg font-semibold text-gray-800 truncate">
              Thêm thành viên tham gia
            </h1>
          </div>
        </div>

        <div className="w-full  p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Chọn thành viên tham gia
              </label>
              <select
                value={form.selectedMember}
                onChange={(e) => change("selectedMember", e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">- Chọn -</option>
                <option value="1">Thành viên 1</option>
                <option value="2">Thành viên 2</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Họ tên <span className="text-red-500">(*)</span>
              </label>
              <input
                type="text"
                placeholder="Nhập họ tên"
                value={form.fullName}
                onChange={(e) => change("fullName", e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Điện thoại
              </label>
              <input
                type="text"
                placeholder="Số điện thoại"
                value={form.phone}
                onChange={(e) => change("phone", e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                placeholder="email@domain.com"
                value={form.email}
                onChange={(e) => change("email", e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Đơn vị
              </label>
              <input
                type="text"
                placeholder="Tên đơn vị"
                value={form.unit}
                onChange={(e) => change("unit", e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Chức vụ
              </label>
              <input
                type="text"
                placeholder="Chức vụ"
                value={form.position}
                onChange={(e) => change("position", e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Chức danh thực hiện
              </label>
              <select
                value={form.role}
                onChange={(e) => change("role", e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">- Chọn -</option>
                <option value="chu-nhiem">Chủ nhiệm</option>
                <option value="thu-ky">Thư ký</option>
                <option value="thanh-vien">Thành viên</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Công việc tham gia
            </label>
            <textarea
              placeholder="Mô tả công việc..."
              value={form.work}
              onChange={(e) => change("work", e.target.value)}
              className="w-full min-h-[160px] px-3 py-2 text-sm border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          <div className="flex items-center justify-end gap-2 pt-2 border-t">
            <button
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50"
              onClick={() => window.history.back()}
            >
              Hủy
            </button>
            <button
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm font-medium shadow-sm inline-flex items-center gap-2"
              onClick={() => {
                console.log("Save member", form);
                // Navigate back to project detail with members tab active
                const projectId = window.location.pathname.split("/")[4]; // Extract project ID from URL
                window.location.href = `/topics/approval/detail/${projectId}`;
              }}
            >
              <UserPlus className="h-4 w-4" />
              <span>Lưu thành viên</span>
            </button>
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default AddProjectMember;
